import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from "../../config/ApiConstants";

export function organisation_delete_tag_action(token, organisId, tagId) {
    return {
      [RSAA]: {
        endpoint: `${API_ENDPOINT}/organisation/tag/${tagId}/delete`,
        method: "POST",
        headers: {
          ...AUTH_HEADERS,
          'Authorization': 'Bearer ' + token,
          organisationId: organisId
        },
  
        // body: JSON.stringify(data),
        types: [
          types.ORGANISATION_DELETE_TAG_REQUEST,
          types.ORGANISATION_DELETE_TAG_RECEIVE,
          {
            type: types.ORGANISATION_DELETE_TAG_FAILURE,
            meta: (action, state, res) => {
              return action, state, res;
            },
          },
        ],
      },
    };
  }
  
  export const reset_organisation_delete_tag_Action = () => {
    return {
      type: types.RESET_ORGANISATION_DELETE_TAG,
      payload: null,
    };
  };